import request from "../request";

export default {
  // 城市-列表
  lists(data) {
    return request.get("/adminArea/lists", data);
  },

  // 城市-添加
  add(data) {
    return request.post("/adminArea/add", data);
  },

  // 城市-编辑
  edit(data) {
    return request.post("/adminArea/edit", data);
  },

  // 城市-删除
  delete(data) {
    return request.post("/adminArea/delete", data);
  },

};
